import Component from '../../../shared/component';

export default class ConversationRatingPopup extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$trigger = this.$element.find('.conversationRatingPopup-close');

    this.bindEvents();
  }

  bindEvents() {
    this.handleClosePopup = this.handleClosePopup.bind(this);

    this.$trigger.on('click.ConversationRatingPopup', this.handleClosePopup);
  }

  unbindEvents() {
    this.$trigger.off('click.ConversationRatingPopup', this.handleClosePopup);
  }

  handleClosePopup() {
    this.$element.hide();
  }
}
